import { createRegisterableComponent } from '@news-mono/web-common'
import React from 'react'
import { PaperPromo } from './PaperPromo'

export const PaperPromoRegistration = createRegisterableComponent(
    'paper-promo',
    () => {
        return <PaperPromo />
    },
)
